import React from 'react';
import ProposalImage from './ProposalImage';

const defaultCaptionStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 600,
  fontSize: 13,
  color: '#000814',
  margin: '8px 0 0 0',
  textAlign: 'center',
};

/**
 * Proposal image with a caption/title below it.
 * @param {string} src - Image source (required)
 * @param {string} title - Caption text below the image
 * @param {string} [alt='Plant proposal'] - Alt text
 * @param {object} [wrapperStyle] - Override or extend ProposalImage wrapper styles
 * @param {object} [imgStyle] - Override or extend img styles
 * @param {object} [captionStyle] - Override or extend caption styles
 * @param {object} [containerStyle] - Override or extend outer container styles
 */
export default function ProposalImageWithCaption({
  src,
  title,
  alt = 'Plant proposal',
  wrapperStyle = {},
  imgStyle = {},
  captionStyle = {},
  containerStyle = {},
}) {
  const mergedCaptionStyle = { ...defaultCaptionStyle, ...captionStyle };

  return (
    <div className="quotation-no-break" style={containerStyle}>
      <ProposalImage src={src} alt={alt} wrapperStyle={wrapperStyle} imgStyle={imgStyle} />
      {title && <div style={mergedCaptionStyle}>{title}</div>}
    </div>
  );
}
